
import { Invite } from "./use-event-guests";

export interface GuestInfo {
  invite_id: string;
  display_name: string;
  phone_number?: string;
  rsvp_status: 'invited' | 'accepted' | 'declined' | 'maybe';
  feedback_text?: string | null;
  suggested_venue?: string | null;
  suggested_time?: string | null;
  claimed_by_user_id?: string | null;
  user_phone_number?: string | null;
  selected_dates?: string[] | null;
  selected_times?: string[] | null; // Add selected_times to the interface
  avatar_url?: string | null;
  user_full_name?: string | null;
  guest_avatar_url?: string | null;
}

export const useProcessInvites = (invites: Invite[] = []) => {
  const processInvites = (): { 
    pendingGuests: GuestInfo[],
    attendingGuests: GuestInfo[],
    notAttendingGuests: GuestInfo[] 
  } => {
    if (!invites) return { pendingGuests: [], attendingGuests: [], notAttendingGuests: [] };
    
    const pending: GuestInfo[] = [];
    const attending: GuestInfo[] = [];
    const notAttending: GuestInfo[] = [];

    invites.forEach((invite) => {
      const guestInfo: GuestInfo = {
        invite_id: invite.invite_id,
        display_name: invite.display_name,
        phone_number: invite.phone_number,
        rsvp_status: (invite.rsvp_status || 'invited') as 'invited' | 'accepted' | 'declined' | 'maybe',
        feedback_text: invite.feedback_text,
        suggested_venue: invite.suggested_venue,
        suggested_time: invite.selected_times ? invite.selected_times.join(', ') : null,
        claimed_by_user_id: invite.claimed_by_user_id,
        user_phone_number: invite.user_phone_number,
        selected_dates: invite.selected_dates,
        selected_times: invite.selected_times, // Include selected_times in guestInfo
        avatar_url: invite.avatar_url,
        user_full_name: invite.user_full_name,
        guest_avatar_url: invite.guest_avatar_url
      };

      if (invite.rsvp_status === 'accepted') {
        attending.push(guestInfo);
      } else if (invite.rsvp_status === 'declined') {
        notAttending.push(guestInfo);
      } else {
        pending.push(guestInfo);
      }
    });

    return { pendingGuests: pending, attendingGuests: attending, notAttendingGuests: notAttending };
  };

  const { pendingGuests, attendingGuests, notAttendingGuests } = processInvites();
  const totalGuests = pendingGuests.length + attendingGuests.length + notAttendingGuests.length;

  return {
    pendingGuests,
    attendingGuests,
    notAttendingGuests,
    totalGuests,
    processInvites
  };
};
